import { render, staticRenderFns } from "./FDropdown.vue?vue&type=template&id=35478134&scoped=true&"
import script from "./FDropdown.vue?vue&type=script&lang=js&"
export * from "./FDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FDropdown.vue?vue&type=style&index=0&id=35478134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35478134",
  null
  
)

export default component.exports